import React, { useState } from 'react';

function getWeekNr(datumStr) {
  if (!datumStr) return null;
  const d = new Date(datumStr);
  const tmp = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dag = tmp.getUTCDay() || 7;
  tmp.setUTCDate(tmp.getUTCDate() + 4 - dag);
  const jaarStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
  return { week: Math.ceil((((tmp - jaarStart) / 86400000) + 1) / 7), jaar: tmp.getUTCFullYear() };
}

function datumNaarWeekInput(datumStr) {
  const r = getWeekNr(datumStr);
  if (!r) return '';
  return `${r.jaar}-W${String(r.week).padStart(2, '0')}`;
}

function weekInputNaarMaandag(weekStr) {
  if (!weekStr) return '';
  const [jaarStr, wStr] = weekStr.split('-W');
  const jaar = parseInt(jaarStr), weekNr = parseInt(wStr);
  const jan4 = new Date(Date.UTC(jaar, 0, 4));
  const maandag = new Date(jan4);
  maandag.setUTCDate(jan4.getUTCDate() - ((jan4.getUTCDay() || 7) - 1) + (weekNr - 1) * 7);
  return maandag.toISOString().split('T')[0];
}

function weekInputNaarVrijdag(weekStr) {
  if (!weekStr) return '';
  const maandag = new Date(weekInputNaarMaandag(weekStr));
  maandag.setUTCDate(maandag.getUTCDate() + 4);
  return maandag.toISOString().split('T')[0];
}

function korteDatum(datumStr) {
  if (!datumStr) return '';
  return new Date(datumStr).toLocaleDateString('nl-BE', { weekday: 'short', day: 'numeric', month: 'short' });
}

// defaultModus: 'week' (kies week, sla vrijdag op) | 'datum' (kies exacte datum)
export default function WeekDatumPicker({
  value, onChange, label, fout, eindDatum = false,
  style: extraStyle,
}) {
  const [modus, setModus] = useState('week');

  const weekVal = datumNaarWeekInput(value);
  const weekInfo = getWeekNr(value);

  const inputStijl = {
    flex: 1, padding: '8px 10px', fontSize: 13, borderRadius: 6,
    border: `1px solid ${fout ? '#E05040' : '#DDD'}`,
    boxSizing: 'border-box',
  };

  return (
    <div style={extraStyle}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
        <label style={{ fontSize: 12, color: fout ? '#C0392B' : '#555' }}>
          {label}{fout ? ` — ${fout}` : ''}
        </label>
        <div style={{ display: 'flex', borderRadius: 6, border: '1px solid #DDD', overflow: 'hidden' }}>
          <button type="button" onClick={() => setModus('week')} style={{
            padding: '2px 8px', fontSize: 10, border: 'none', cursor: 'pointer',
            background: modus === 'week' ? '#1F3864' : '#fff',
            color: modus === 'week' ? '#fff' : '#888',
          }}>Week</button>
          <button type="button" onClick={() => setModus('datum')} style={{
            padding: '2px 8px', fontSize: 10, border: 'none', borderLeft: '1px solid #DDD', cursor: 'pointer',
            background: modus === 'datum' ? '#1F3864' : '#fff',
            color: modus === 'datum' ? '#fff' : '#888',
          }}>Datum</button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {modus === 'week' ? (
          <>
            <input type="week" value={weekVal}
              onChange={e => onChange(eindDatum ? weekInputNaarVrijdag(e.target.value) : weekInputNaarMaandag(e.target.value))}
              style={inputStijl} />
            {value && (
              <span style={{ fontSize: 11, color: '#888', whiteSpace: 'nowrap' }}>
                {korteDatum(value)}
              </span>
            )}
          </>
        ) : (
          <>
            <input type="date" value={value || ''}
              onChange={e => onChange(e.target.value)}
              style={inputStijl} />
            {weekInfo && (
              <span style={{ fontSize: 12, fontWeight: 600, color: '#1F3864', whiteSpace: 'nowrap' }}>
                W{weekInfo.week}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
}
